import { useTranslator } from '@Localization';
import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';
import { S_ClipLoader } from '../../../../../../../../design/loaders/clipLoader/S_ClipLoader';
import { S_Modal } from '../../../../../../../../design/modals/modal/S_Modal';

interface IProps {
  show: boolean;
}

export const ProcessingStepModal = observer((props: IProps): ReactElement => {
  const { t } = useTranslator();
  const { show } = props;
  return (
    <S_Modal
      headerText={`${t('new.projects.details.import_annotations.header')} - ${t('new.projects.details.import_annotations.steps.processing.header')}`}
      isOpen={show}
    >
      <p>{t('new.projects.details.import_annotations.steps.processing.body')}</p>
      <S_ClipLoader />
    </S_Modal>
  );
});
